import React from 'react';

const ManageStore = () => {
  return (
    <div className="card shadow-sm rounded-3 p-4">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold">Manage Store</h2>
          <p className="text-muted mb-0">Configure store settings and preferences</p>
        </div>
        <button className="btn btn-primary">
          Save Changes
        </button>
      </div>

      {/* Store Settings Sections */}
      <div className="row mb-4">
        <div className="col-md-6">
          <div className="card shadow-sm p-3">
            <h6 className="fw-bold">Store Information</h6>
            <p className="text-muted small mb-2">Basic store details and contact information</p>
            <button className="btn btn-outline-primary btn-sm">Configure</button>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card shadow-sm p-3">
            <h6 className="fw-bold">Payment Settings</h6>
            <p className="text-muted small mb-2">Configure payment methods and processing</p>
            <button className="btn btn-outline-primary btn-sm">Configure</button>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-6">
          <div className="card shadow-sm p-3">
            <h6 className="fw-bold">Tax Settings</h6>
            <p className="text-muted small mb-2">Set up tax rates and calculations</p>
            <button className="btn btn-outline-primary btn-sm">Configure</button>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card shadow-sm p-3">
            <h6 className="fw-bold">Shipping Settings</h6>
            <p className="text-muted small mb-2">Configure shipping options and rates</p>
            <button className="btn btn-outline-primary btn-sm">Configure</button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="d-flex align-items-center justify-content-center" style={{ height: '400px' }}>
        <div className="text-center">
          <h3 className="text-muted">Store Management</h3>
          <p className="text-muted">This section is under development</p>
          <p className="text-muted small">Configure store settings, payment methods, tax rates, and shipping options.</p>
        </div>
      </div>
    </div>
  );
};

export default ManageStore;
